import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface KioskState {
  isHomeMenuOpen: boolean;
}

const initialState: KioskState = {
  isHomeMenuOpen: true,
};

export const kioskSlice = createSlice({
  name: "kiosk",
  initialState,
  reducers: {
    toggleHomeMenu: (state) => {
      state.isHomeMenuOpen = !state.isHomeMenuOpen;
    },
  },
});

export const selectIsHomeMenuOpen = (state: RootState) => {
  return state.kiosk.isHomeMenuOpen;
};

export const { toggleHomeMenu } = kioskSlice.actions;

// eslint-disable-next-line import/no-default-export
export default kioskSlice.reducer;
